import styled, { css } from "styled-components";
import { responsiveMap } from "../../Grid/_utils/responsiveObserve";
import { ILandingSectionBaseProps } from "./LandingSectionBase";

export const _LandingSectionBaseRoot = styled("section")<{
  $bg?: {
    desktop?: string;
    mobile?: string;
  };
  $imageLeft?: boolean;
  $topPosition?: boolean;
  $topContentSize?: ILandingSectionBaseProps["topContentSize"];
  $hasTopContent?: boolean;
  $mobileMinHeight?: string;
}>(
  ({
    $bg,
    $imageLeft,
    $topPosition,
    $topContentSize,
    $hasTopContent,
    $mobileMinHeight,
  }) => {
    const { desktop: desktopBg, mobile: mobileBg } = $bg || {};
    const topArea = $topPosition
      ? "1 / 1 / 2 / 3"
      : $imageLeft
      ? "1 / 2 / 2 / 3"
      : "1 / 1 / 2 / 2";
    const middleArea = $topPosition
      ? $imageLeft
        ? "2 / 1 / 3 / 2"
        : "2 / 2 / 3 / 3"
      : $imageLeft
      ? "1 / 1 / 3 / 2"
      : "1 / 2 / 3 / 3";
    const bottomArea = $topPosition
      ? $imageLeft
        ? `${$hasTopContent ? "2" : "1"} / 2 / 3 / 3`
        : `${$hasTopContent ? "2" : "1"} / 1 / 3 / 2`
      : $imageLeft
      ? `${$hasTopContent ? "2" : "1"} / 2 / 3 / 3`
      : `${$hasTopContent ? "2" : "1"} / 1 / 3 / 2`;
    return css`
      &.landing-section-base {
        position: relative;
        // font-family: $main-font;
        // background-color: var(--bg-color);
        margin-bottom: -1px;
        ${desktopBg ? `background-image: url(${desktopBg});` : ""}
        background-size: 100% auto;
        background-repeat: no-repeat;

        @media ${responsiveMap.maxLg} {
          ${mobileBg || desktopBg
            ? css`
                background-image: url(${mobileBg || desktopBg});
                background-size: cover;
              `
            : ""}
        }
      }

      & .landing-section-base {
        &__bg-behind {
          position: absolute;
          inset: 0;
          z-index: 0;
          overflow: hidden;
          pointer-events: none;
        }

        &__head {
          // color: #000000;
          // font-family: $main-font;
          position: relative;
          // min-height: 51.945vw;

          &__container {
            position: relative;
            z-index: 1;
            padding: 40px 48px;
            display: grid;
            grid-template-columns: repeat(2, 50%);
            grid-template-rows: ${$topPosition
              ? "0fr 0fr"
              : $topContentSize === "small"
              ? "1fr 8fr"
              : "1fr 2fr"};
            grid-column-gap: 0px;
            grid-row-gap: 0px;

            &.has-children {
              grid-template-columns: unset;
              grid-template-rows: unset;
              grid-column-gap: unset;
              grid-row-gap: unset;
            }

            @media ${responsiveMap.maxLg} {
              display: flex;
              flex-direction: column;
              padding: 47px 24px 40px;
            }
          }

          &__top {
            flex: 1;
            grid-area: ${topArea};
            display: flex;
            align-items: flex-end;
            justify-content: center;

            max-width: ${$topPosition ? "700px" : "466px"};
            margin: ${$topPosition ? "0 auto 40px" : "0 auto"};

            @media ${responsiveMap.maxLg} {
              margin: 0 auto;
            }

            &.align-left {
              justify-content: flex-start;
              @media ${responsiveMap.maxLg} {
                justify-content: center;
              }
            }

            &__container {
              width: 100%;
              text-align: center;
              &.align-left {
                text-align: ${$topPosition ? "center" : "left"};
                @media ${responsiveMap.maxLg} {
                  text-align: center;
                }
              }

              @media ${responsiveMap.maxLg} {
                // margin-bottom: 32px;
              }
            }
          }
          &__middle {
            grid-area: ${middleArea};
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            ${$topPosition ? "" : "aspect-ratio: var(--aspect-ratio-mobile);"}

            @media ${responsiveMap.maxLg} {
              ${$mobileMinHeight
                ? `min-height: ${$mobileMinHeight}; aspect-ratio: unset;`
                : ""}
            }

            &__container {
              text-align: center;
              padding: 0px;
              width: 100%;
              @media ${responsiveMap.maxLg} {
                padding: 0px;
              }
            }
          }
          &__bottom {
            flex: 1;
            grid-area: ${bottomArea};
            display: flex;
            align-items: flex-start;
            justify-content: center;
            text-align: center;

            max-width: 466px;
            margin: 0 auto;
            width: 100%;

            &.align-left {
              justify-content: flex-start;
              text-align: left;
              ${$topPosition ? "align-items: center;" : ""}
            }
            &.fill-top-content {
              align-items: center;
            }

            @media ${responsiveMap.maxLg} {
              margin-top: 24px;
            }

            &__container {
              width: 100%;
            }
          }

          &__img {
            cursor: pointer;
            img {
              width: 100%;
              aspect-ratio: 1/1;
            }
          }

          &__sushi {
            max-width: 168px;
          }
          &__logo {
            margin-bottom: 50px;
            max-width: 329px;
            width: 100%;
            aspect-ratio: 2/1;
          }

          &__content {
            max-width: 438px;
            width: 100%;
            margin: 0 auto;
            // text-align: center;
          }
          &__cta {
            margin-top: 31px;
          }
        }
      }

      @keyframes loaderAnmation {
        0% {
          opacity: 0;
          transform: translateY(110%);
        }
        60% {
          transform: translateY(0);
        }
        100% {
          opacity: 1;
        }
      }
    `;
  }
);
